export default "__VITE_ASSET__VlNYX94y__"